import repository from '@/repositories/repository'

export default baseUrl => {

    baseUrl = `${baseUrl}/atendimento-enfermagem`

    const headers = { responseType: "arraybuffer" }

    return {
        solicitacaoExamesLaboratoriais(id) {

            return repository.get(`${baseUrl}/solicitacao-exames-laboratoriais/${id}`, headers)
        },
        prescricaoInterna(id) {

            return repository.get(`${baseUrl}/prescricao-interna/${id}`, headers)
        },
    }
}
